import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import TopChannels from '@features/campaigns/performance/components/TopCharts/components/TopChannels/TopChannels.tsx';
import TopContent from '@features/campaigns/performance/components/TopCharts/components/TopContent/TopContent.tsx';
import TopGeo from '@features/campaigns/performance/components/TopCharts/components/TopGeo/TopGeo.tsx';
import { QUERY_KEYS } from '@features/campaigns/performance/consts/queryKeys.ts';
import { getCampaignTopCharts } from '@features/campaigns/performance/services/getCampaignTopCharts.ts';

interface TopChartsProps {
  isCampaignSelfService: boolean;
}

export function TopCharts({ isCampaignSelfService }: TopChartsProps) {
  const { campaignId } = useParams();

  const { data, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.TOP_CHARTS, campaignId],
    queryFn: () => {
      if (campaignId) {
        return getCampaignTopCharts(campaignId);
      }

      return null;
    },
  });

  const geoData = data
    ? {
        provinces: data.provinces,
        regions: data.regions,
      }
    : null;

  return (
    <section data-testid='top-charts'>
      <TopGeo isFetching={isFetching} data={geoData} />
      <TopContent isFetching={isFetching} data={data?.genres} />
      {isCampaignSelfService && <TopChannels isFetching={isFetching} data={data?.channels} />}
    </section>
  );
}
